<template>
  <section ref="raiz" class="lluvia-sobres">
    <div class="stars-container">
      <div 
        v-for="n in 50" 
        :key="n" 
        class="star" 
        :style="generateStarStyle()"
      ></div>
    </div>

    <div class="contenido">
      <h2 ref="tituloRef" class="titulo">
        <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        <span class="serif">Lluvia</span><br />
        <span class="script">de sobres</span>
      </h2>

      <p ref="textoRef" class="texto">
     Mi próximo destino es la mágica ciudad de Paris ✨<br />
Si deseas ser parte de este sueño,<br /> tendremos lluvia de sobres (dinero)<br />
Cada granito de amor me acerca más a caminar bajo la Torre Eiffel 🤍.
       
      </p>

      <img ref="sobreRef" :src="sobrePng" alt="Sobre" class="icono-sobre" />

      <p ref="graciasRef" class="gracias">¡GRACIAS!</p>
    </div>

    <div class="lluvia lluvia-izq" aria-hidden="true"></div>
    <div class="lluvia lluvia-der" aria-hidden="true"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import sobrePng from '@/assets/ss.png'

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const graciasRef = ref(null)

    // Función para generar las estrellas
    const generateStarStyle = () => {
      return {
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 3 + 1}px`,
        height: `${Math.random() * 3 + 1}px`,
        animationDuration: `${Math.random() * 3 + 2}s`,
        animationDelay: `${Math.random() * 4}s`
      }
    }

    onMounted(async () => {
      await nextTick()

      // 1. Pre-configurar estados invisibles para evitar saltos en móvil
      const serifEl = tituloRef.value?.querySelector('.serif')
      const scriptEl = tituloRef.value?.querySelector('.script')
      
      gsap.set([serifEl, scriptEl, textoRef.value, sobreRef.value, graciasRef.value], { 
        opacity: 0, 
        y: 30 
      })

      // 2. Observer para disparar animación al entrar al viewport (Cellular Friendly)
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const tl = gsap.timeline({ defaults: { ease: 'power3.out', duration: 0.8 } })

            tl.to(serifEl, { opacity: 1, y: 0, filter: 'blur(0px)', delay: 0.2 })
              .to(scriptEl, { opacity: 1, y: 0, duration: 0.6 }, "-=0.4")
              .to(textoRef.value, { opacity: 1, y: 0 }, "-=0.3")
              .to(sobreRef.value, { opacity: 1, y: 0, scale: 1, ease: 'back.out(1.7)' }, "-=0.2")
              .to(graciasRef.value, { opacity: 1, y: 0 }, "-=0.3")

            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' })

      if (raiz.value) observer.observe(raiz.value)
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      graciasRef,
      sobrePng,
      generateStarStyle
    }
  }
}
</script>

<style scoped>
.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background-image: 
    linear-gradient(to bottom, 
      rgba(0, 0, 0, 0.516) 60%, 
      rgba(0, 0, 0, 0.7) 85%, 
      rgba(0, 0, 0, 0.95) 100%
    ),
    url('@/assets/descarga (3) - copia - copia.png');
  background-size: cover;
  background-position: center center; 
  background-repeat: no-repeat;
  overflow: hidden;
  min-height: 100vh; /* Asegura espacio para ver animación */
}

/* SISTEMA DE ESTRELLAS */
.stars-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.star {
  position: absolute;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 5px #fff;
  animation: twinkle linear infinite;
}

@keyframes twinkle {
  0%, 100% { opacity: 0.2; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.3); }
}

.contenido { 
  position: relative; 
  z-index: 2; 
}

.titulo {
  margin: 0 0 10px;
  line-height: 1.05;
}

.titulo .serif {
  font-family: 'nombre', cursive;
  font-size: 56px;
  color: #a48250;
  display: inline-block;
  filter: blur(5px); /* Estado inicial */
}

.titulo .script {
  font-family: 'nombre', cursive;
  font-size: 44px;
  color: #a48250;
  font-weight: 400;
  display: inline-block;
}

.texto {
  font-family: 'quote', serif;
  color: #f4efef;
  font-size: 17px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 18px;
}

.icono-sobre {
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.3));
}

.gracias {
  font-family: 'padres', serif;
  font-size: 24px;
  color: #babbb3;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

@media (max-width: 380px) {
  .titulo .serif { font-size: 50px; }
  .titulo .script { font-size: 40px; }
  .icono-sobre { width: 96px; }
}
</style>